import { fadeIn, fadeOut } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'

export const StyledBackdrop = styled('div', {
    bgc: 'rgba(0, 0, 0, .5)',
    inset: 0,
    overflow: 'hidden auto',
    position: 'fixed',
    transition: '$default',
    zIndex: '$backdrop',

    variants: {
        isOpen: {
            true: {
                ...createAnimation(fadeIn),
                opacity: 1,
                visibility: 'visible',
            },
            false: {
                ...createAnimation(fadeOut),
                opacity: 0,
                visibility: 'hidden',
            },
        },
    },
})
